export default __webpack_public_path__ + "static/media/Potent Bittersharp.3bc4d4a9.jpg";